import React, { useState, useEffect } from "react";
import MyContext from "./MyContext";
import { authenticateUser } from "../helpers/apiCalls";
import axios from "axios";

const initialProduct = {
  product_id: "",
  title: "",
  price: 0,
  prevPrice: 0,
  description:
    "How to and tutorial videos of cool CSS effect, Web Design ideas,JavaScript libraries, Node.",
  content:
    "Welcome to our channel Dev AT. Here you can learn web designing, UI/UX designing, html css tutorials, css animations and css effects, javascript and jquery tutorials and related so on.",
  category: "",
};

const Myprovider = (props) => {
  const stev = "aaaaaaaaaaaaaa";

  const [user, setUser] = useState();
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [orderDetails, setOrderDetails] = useState();
  const [detailProduct, setDetailProduct] = useState([]);
  const [product, setProduct] = useState(initialProduct);
  const [products, setProducts] = useState([]);
  const [callback, setCallback] = useState(false);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [sort, setSort] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [result, setResult] = useState(0);
  const [isLogged, setIsLogged] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [cart, setCart] = useState([]);
  const [history, setHistory] = useState([]);
  const [onEdit, setOnEdit] = useState(false);
  const [id, setId] = useState("");
  const [total, setTotal] = useState(0);
  const [error, setError] = useState({ message: "" });
  const [images, setImages] = useState([]);
  const [authIsDone, setAuthIsDone] = useState(false);
  const [billAddressId, setBillAddressId] = useState(null);

  const [openState, setOpenState] = useState(false);
  const [positionRight, setPositionRight] = useState(-450);

  useEffect(() => {
    const authMe = async () => {
      try {
        const result = await authenticateUser();
        if (result.error) {
          setUser();
          setIsLogged(false);
          setAuthIsDone(true);
          return;
        }
        setUser(result);
        setCart(result.cart);
        setIsLogged(true);
        if (result.role === 1) setIsAdmin(true);
        setAuthIsDone(true);
      } catch (error) {
        console.log(error);
      }
    };
    authMe();
  }, [callback]);

  useEffect(() => {
    const getCategories = async () => {
      const res = await axios.get("/api/category");
      setCategories(res.data);
    };
    getCategories();
  }, [callback]);

  return (
    <MyContext.Provider
      value={{
        openState, setOpenState,
        positionRight, setPositionRight,
        stev,
        user,
        setUser,
        menu,
        setMenu,
        loading,
        setLoading,
        isCheck,
        setIsCheck,
        orderDetails,
        setOrderDetails,
        detailProduct,
        setDetailProduct,
        product,
        setProduct,
        products,
        setProducts,
        callback,
        setCallback,
        category,
        setCategory,
        sort,
        setSort,
        search,
        setSearch,
        page,
        setPage,
        result,
        setResult,
        categories,
        setCategories,
        isLogged,
        setIsLogged,
        isAdmin,
        setIsAdmin,
        cart,
        setCart,
        history,
        setHistory,
        onEdit,
        setOnEdit,
        id,
        setId,
        total,
        setTotal,
        error,
        images,
        setImages,
        setError,
        authIsDone,
        setAuthIsDone,
        billAddressId,
        setBillAddressId,
      }}
    >
      {props.children}
    </MyContext.Provider>
  );
};

export default Myprovider;
